/**
 * Client-safe config (VITE_* only). No secrets here.
 */
export const env = {
  /** Base URL for future parse API (`https://api.example.com`) */
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, ""),
  /** Product name (reports, title, hero). Override with VITE_APP_NAME. */
  appName: import.meta.env.VITE_APP_NAME ?? "DMeterLine",
  /** Public contact for licensing / purchase / inquiries. */
  contactEmail:
    (import.meta.env.VITE_CONTACT_EMAIL as string | undefined) ??
    "dpyly.work@gmail.com",
} as const;
